"use client";

import Image from "next/image";
import { useI18n } from "@/i18n/I18nProvider";

export default function Banner() {
  const { t } = useI18n();
  return (
    <section className="relative w-full h-[204px] overflow-hidden bg-[#0b3f3e]">
      {/* Doctor + hospital background photo */}
      <Image
        src="/images/doctor-banner.jpg"
        alt="Chinese male doctor in front of a modern hospital"
        fill
        sizes="(max-width: 430px) 100vw, 430px"
        className="object-cover object-[70%_24%]"
        priority
      />

      {/* Teal legibility overlay, matching the master art direction */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(90deg, rgba(3,38,40,0.96) 0%, rgba(4,47,48,0.86) 34%, rgba(5,56,54,0.42) 62%, rgba(6,58,56,0.06) 82%, rgba(6,58,56,0) 100%), linear-gradient(180deg, rgba(3,38,40,0.30) 0%, rgba(3,38,40,0) 42%)",
        }}
      />

      {/* Copy */}
      <div className="absolute left-5 top-3 z-10 w-[62%]">
        <h1 className="text-[26px] font-extrabold leading-[1.14] tracking-[-0.2px] text-white">
          {t("Trusted")}
          <br />
          {t("Medical Care")}
          <br />
          {t("in China")}
        </h1>
        <p className="mt-1.5 text-[12px] tracking-[0.1px] text-white/85">
          {t("Checkup · Treatment · Surgery · Recovery")}
        </p>
        <span className="block mt-2 h-[2px] w-7 rounded-full bg-[#BFE0D3]/70" aria-hidden="true" />
      </div>
    </section>
  );
}
